(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["forgd-towel-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('forgd-towel-showcase')) {
    customElements.define('forgd-towel-showcase', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (this.abort || !this.isConnected) return;
        this.slides = [...this.querySelectorAll('[data-slide]')];
        if (this.slides.length < 2) return;
        this.abort = new AbortController();
        const listen = (node, event, callback) => node.addEventListener(event, callback, { signal: this.abort.signal });
        this.index = Math.max(0, this.slides.findIndex(slide => slide.classList.contains('is-active')));
        this.sequence = 0;
        this.enabled = this.dataset.autoplay === 'true';
        this.interval = Math.max(2000, Number(this.dataset.interval) || 4000);
        this.paused = false;
        this.hovered = false;
        this.editorSelected = false;
        this.inView = !('IntersectionObserver' in window);
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.dots = [...this.querySelectorAll('[data-go-to]')];
        this.toggle = this.querySelector('[data-toggle]');

        listen(this, 'click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-toggle')) {
            this.paused = !this.paused;
            this.updateToggle();
            this.schedule();
          } else if (button.hasAttribute('data-go-to')) {
            this.goTo(Number(button.dataset.goTo), true);
          } else if (button.hasAttribute('data-next')) {
            this.goTo(this.index + 1, true);
          } else if (button.hasAttribute('data-previous')) {
            this.goTo(this.index - 1, true);
          }
        });
        listen(this, 'keydown', event => {
          if (!event.target.closest('.forgd-towel-showcase__controls')) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.goTo(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
          }
        });
        listen(this, 'pointerenter', event => {
          if (event.pointerType !== 'mouse') return;
          this.hovered = true;
          this.schedule();
        });
        listen(this, 'pointerleave', () => { this.hovered = false; this.schedule(); });
        listen(this, 'focusin', event => {
          if (event.target === this.toggle) return;
          this.pause();
        });
        listen(document, 'visibilitychange', () => this.schedule());
        listen(this.motion, 'change', () => { this.updateToggle(); this.schedule(); });
        listen(document, 'shopify:block:select', event => {
          const selected = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (selected < 0) return;
          this.editorSelected = true;
          this.goTo(selected);
        });
        listen(document, 'shopify:block:deselect', event => {
          if (!this.slides.some(slide => slide.dataset.blockId === event.detail.blockId)) return;
          this.editorSelected = false;
          this.schedule();
        });

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.inView = entries[0].isIntersecting;
            if (this.inView) this.preloadNext();
            this.schedule();
          }, { threshold: 0.05 });
          this.observer.observe(this);
        }
        this.classList.add('is-ready');
        this.updateToggle();
        this.schedule();
      }

      preloadNext() {
        const image = this.slides[(this.index + 1) % this.slides.length].querySelector('img');
        if (image) image.loading = 'eager';
      }

      pause() {
        this.paused = true;
        this.updateToggle();
        this.schedule();
      }

      updateToggle() {
        if (!this.toggle) return;
        this.toggle.hidden = this.motion.matches;
        this.toggle.setAttribute('aria-label', this.paused ? 'Play slideshow' : 'Pause slideshow');
        this.toggle.querySelector('[data-pause-icon]').toggleAttribute('hidden', this.paused);
        this.toggle.querySelector('[data-play-icon]').toggleAttribute('hidden', !this.paused);
      }

      schedule() {
        clearTimeout(this.timer);
        if (!this.isConnected || !this.enabled || this.paused || this.hovered || this.editorSelected ||
            !this.inView || this.motion.matches || document.hidden || this.loading) return;
        this.timer = setTimeout(() => this.goTo(this.index + 1), this.interval);
      }

      async goTo(target, manual = false) {
        if (manual) this.pause();
        clearTimeout(this.timer);
        target = (target + this.slides.length) % this.slides.length;
        const sequence = ++this.sequence;
        this.loading = true;
        const image = this.slides[target].querySelector('img');
        if (image) {
          image.loading = 'eager';
          try { await image.decode(); } catch (_) { /* Keep the current design if an image fails to load. */ }
          if (!image.naturalWidth) {
            if (sequence === this.sequence) { this.loading = false; this.schedule(); }
            return;
          }
        }
        if (!this.isConnected || sequence !== this.sequence) return;
        this.index = target;
        this.slides.forEach((slide, index) => {
          slide.classList.toggle('is-active', index === target);
          slide.setAttribute('aria-hidden', String(index !== target));
        });
        this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === target)));
        if (manual) {
          const status = this.querySelector('[data-status]');
          if (status) status.textContent = `${this.slides[target].dataset.title}. Design ${target + 1} of ${this.slides.length}.`;
        }
        this.loading = false;
        this.preloadNext();
        this.schedule();
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        clearTimeout(this.timer);
        this.sequence = (this.sequence || 0) + 1;
        this.observer?.disconnect();
        this.abort?.abort();
        this.abort = null;
        this.loading = false;
        this.classList.remove('is-ready');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
